import React, { useMemo } from 'react'
import { useContext } from 'react'
import { countDuplicate } from '../../helpers/helpers'
import { DataContext } from '../../contexts/DataProvider'
import { Paper, Typography, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import CircullarChart from './CircullarChart'
import Title from '../Title'

const ContractDevices: React.FC = () => {
  const { activeContract } = useContext(DataContext)

  const getDevice = (platform: 'iOS' | 'Android' | 'No information') => {
    if (activeContract && activeContract.usersDevices) {
      if (platform === 'No information') {
        const usersWithoutDevice = activeContract.usersDevices.filter((data) => data?.deviceContext === undefined)
        return usersWithoutDevice
      } else {
        const usersWithDevice = activeContract.usersDevices.filter((data) => data?.deviceContext)
        const osDevices = usersWithDevice.filter((device) => device?.deviceContext?.platform === platform)
        return osDevices
      }
    } else {
      return '-'
    }
  }
  const getVersions = (devices) => {
    if (devices && Array.isArray(devices) && devices.length > 0) {
      const versions = devices.map((device) => device.deviceContext.version).sort((a, b) => a - b)
      const versionsObj = countDuplicate(versions)
      return Object.entries(versionsObj)
        .sort((a, b) => a[0] - b[0])
        .map(([key, value], id) => (
          <div className="version-count" key={`${key}${id}`}>
            {key} - {value}
          </div>
        ))
    }
    return <div className="version-count">{'-'}</div>
  }
  const SyledPaper = styled(Paper)(() => ({
    padding: '1rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  }))

  const StyledChartPaper = styled(Paper)(() => ({
    padding: '1rem',
    height: 340,
  }))

  return useMemo(() => {
    return (
      <>
        <Grid item xs={12} md={6} lg={6}>
          <StyledChartPaper>
            <CircullarChart />
          </StyledChartPaper>
        </Grid>

        <Grid item xs={6} md={3} lg={3}>
          <SyledPaper>
            <Title>Devices</Title>
            <Typography>iOS</Typography>
            <Typography component="p" variant="h5">
              {getDevice('iOS').length}
            </Typography>
            <Typography>Android</Typography>
            <Typography component="p" variant="h5">
              {getDevice('Android').length}
            </Typography>
            <Typography>No information</Typography>
            <Typography component="p" variant="h5">
              {getDevice('No information').length}
            </Typography>
          </SyledPaper>
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <SyledPaper>
            <Title>Versions</Title>
            <Typography>iOS</Typography>
            {getVersions(getDevice('iOS'))}

            <Typography>Android</Typography>
            {getVersions(getDevice('Android'))}
          </SyledPaper>
        </Grid>
      </>
    )
  }, [activeContract])
}
export default ContractDevices
